import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const WasteCollectionTable = ({ calenderCollectionData, setFooterDesc }) => {
  const { t } = useTranslation();
  // const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const monthNames = [t('jan'), t('feb'), t('mar'), t('apr'), t('May'), t('jun'), t('jul'), t('aug'), t('sep'), t('oct'), t('nov'), t('dec')];
  let tableData = {};
  let headerColors = {};
  let description = {};

  // Process the collection into a structured format
  calenderCollectionData?.COLLECTION?.forEach((item) => {
    const [year, month, day] = item.DATE.split('-').map((num) => parseInt(num, 10));
    const monthName = monthNames[month - 1];
    const binType = item.BIN_TYPE;
    const desc = item.DESCRIPTION;

    // Set the header color for each bin type
    if (!headerColors[binType]) {
      headerColors[binType] = item.COLOR;
    }
    if (!description[desc]) {
      if (item.DESCRIPTION) {
        description[desc] = item.DESCRIPTION ? item.DESCRIPTION : '';
      }
    }

    if (!tableData[year]) {
      tableData[year] = {};
    }
    if (!tableData[year][monthName]) {
      tableData[year][monthName] = {};
    }
    if (!tableData[year][monthName][binType]) {
      tableData[year][monthName][binType] = [];
    }

    tableData[year][monthName][binType].push(day);
  });

  const binTypes = Object.keys(headerColors).sort();
  const smallScreenArray = (array, chunkSize) => {
    const result = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }
    return result;
  };
  const smallScreenTable = smallScreenArray(binTypes, 2);
  const footerDescription = Object.keys(description).sort();

  useEffect(() => {
    setFooterDesc(footerDescription);
  }, []);

  const isSmallScreen = window.matchMedia('(max-width: 768px)').matches;
  return (
    <div className="container-xxl mb-2" style={{ backgroundColor: '#F3F2F1' }}>
      {isSmallScreen ? (
        <>
          {smallScreenTable.length > 0 ? (
            <>
              {smallScreenTable.map((data, index) => {
                return (
                  <table className="mt-2" style={{ width: '100%' }} key={index}>
                    <thead>
                      <tr className="tableTitle">
                        <th className="text-wrap tableTitleName" style={{ backgroundColor: '#DDDDDD', color: 'black' }}>
                          {t('year')}
                        </th>
                        <th className="text-wrap tableTitleName" style={{ backgroundColor: '#DDDDDD', color: 'black' }}>
                          {t('month')}
                        </th>
                        {data.map((binType) => (
                          <th key={binType} className="text-wrap tableTitleName" style={{ backgroundColor: headerColors[binType], color: 'white' }}>
                            {binType}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {Object.entries(tableData)
                        .sort((a, b) => a[0] - b[0])
                        .map(([year, months]) =>
                          Object.entries(months)
                            .sort((a, b) => monthNames.indexOf(a[0]) - monthNames.indexOf(b[0]))
                            .map(([month, types], monthIndex) => (
                              <tr key={`${year}-${month}`}>
                                {monthIndex === 0 && (
                                  <td rowSpan={Object.keys(months).length} className="text-wrap tableTitleName fw-bold" style={{ backgroundColor: '#DDDDDD', color: 'black' }}>
                                    {year}
                                  </td>
                                )}
                                <td className="text-wrap tableTitleName  fw-bold" style={{ backgroundColor: '#F3F2F1', color: 'black' }}>
                                  {month}
                                </td>
                                {data.map((binType) => {
                                  if (types[binType]) {
                                    return (
                                      <td key={binType} className="text-wrap tableTitleName" style={{ backgroundColor: '#DDDDDD', color: 'black' }}>
                                        {types[binType] ? types[binType].join(', ') : ''}
                                      </td>
                                    );
                                  } else {
                                    return (
                                      <td key={binType} className="text-wrap tableTitleName" style={{ backgroundColor: '#F3F2F1', color: 'black' }}>
                                        {types[binType] ? types[binType].join(', ') : ''}
                                      </td>
                                    );
                                  }
                                })}
                              </tr>
                            ))
                        )}
                    </tbody>
                  </table>
                );
              })}
            </>
          ) : (
            'something went wrong'
          )}
        </>
      ) : (
        <table className="" style={{ width: '100%' }}>
          <thead>
            <tr className="tableTitle">
              <th className="text-wrap tableTitleName" style={{ backgroundColor: '#DDDDDD', color: 'black' }}>
                {t('year')}
              </th>
              <th className="text-wrap tableTitleName" style={{ backgroundColor: '#DDDDDD', color: 'black' }}>
                {t('month')}
              </th>
              {binTypes.map((binType) => (
                <th key={binType} className="text-wrap tableTitleName" style={{ backgroundColor: headerColors[binType], color: 'white' }}>
                  {binType}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Object.entries(tableData)
              .sort((a, b) => a[0] - b[0])
              .map(([year, months]) =>
                Object.entries(months)
                  .sort((a, b) => monthNames.indexOf(a[0]) - monthNames.indexOf(b[0]))
                  .map(([month, types], monthIndex) => (
                    <tr key={`${year}-${month}`}>
                      {monthIndex === 0 && (
                        <td rowSpan={Object.keys(months).length} className="text-wrap tableTitleName fw-bold" style={{ backgroundColor: '#DDDDDD', color: 'black' }}>
                          {year}
                        </td>
                      )}
                      <td className="text-wrap tableTitleName  fw-bold" style={{ backgroundColor: '#F3F2F1', color: 'black' }}>
                        {month}
                      </td>
                      {binTypes.map((binType) => {
                        if (types[binType]) {
                          return (
                            <td key={binType} className="text-wrap tableTitleName" style={{ backgroundColor: '#DDDDDD', color: 'black' }}>
                              {types[binType] ? types[binType].join(', ') : ''}
                            </td>
                          );
                        } else {
                          return (
                            <td key={binType} className="text-wrap tableTitleName" style={{ backgroundColor: '#F3F2F1', color: 'black' }}>
                              {types[binType] ? types[binType].join(', ') : ''}
                            </td>
                          );
                        }
                      })}
                    </tr>
                  ))
              )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default WasteCollectionTable;
